import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('tireo_token');
    localStorage.removeItem('tireo_user');
    setUser(null);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('tireo_token');
    const savedUser = localStorage.getItem('tireo_user');
    
    if (token && savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        setUser(parsedUser);
        // Verify token is still valid
        authAPI.me()
          .then(res => {
            setUser(res.data);
            localStorage.setItem('tireo_user', JSON.stringify(res.data));
          })
          .catch((err) => {
            // Only logout on 401 errors, not network errors
            if (err.response?.status === 401) {
              logout();
            }
          })
          .finally(() => setLoading(false));
      } catch (e) {
        // Invalid JSON in localStorage
        logout();
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [logout]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('tireo_token', res.data.token);
    localStorage.setItem('tireo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem('tireo_token', res.data.token);
    localStorage.setItem('tireo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const refreshUser = async () => {
    try {
      const res = await authAPI.me();
      setUser(res.data);
      localStorage.setItem('tireo_user', JSON.stringify(res.data));
    } catch (e) {
      console.error('Failed to refresh user', e);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
